module.exports = __webpack_public_path__ + "static/media/spindl_logo-xxxhdpi.78688ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spindl_logo-xxxhdpi.png
// module id = 542
// module chunks = 0